class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    this.pageNum = '&page=2'

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) {
      const globalContentLoadingDiv = document.getElementById('ProductGridContainer');
      document.getElementsByClassName('footer')[0].style.marginTop = '15px';
      const loadingSpinner = document.getElementsByClassName('custom-page-fully-loaded-spinner')[0];
      if (loadingSpinner) {
        loadingSpinner.parentElement.style.textAlign = 'center';
        loadingSpinner.classList.remove('hidden');
      }
      facetWrapper.addEventListener('keyup', onKeyUpEscape);
      var global_product_filter = document.querySelector('[aria-label="Products (0 selected)"]');
      var global_product_checkbox = document.querySelector('input[value="Wargame Trader"]');
      // If we're already filtering by wargame trader products
      if (FacetFiltersForm.hasGlobalVendorFilter(FacetFiltersForm.searchParamsInitial)) {
        var activeFilters = document.getElementsByClassName("active-facets");
        var mobileActiveFilters = document.getElementsByClassName("active-facets-mobile");
        var mobileProductFilter = document.getElementById(document.querySelector('[id^="Details-Mobile-filter.p.vendor-template--"]').id);
        var global_product_filter = document.querySelector('[aria-label="Products (1 selected)"]');
        global_product_filter.style.display = "none";
        global_product_filter.parentElement.style.marginRight = '0px';
        if (mobileProductFilter) {
          mobileProductFilter.style.display = "none";
        }
        var url = window.location.href;
        url = url.includes("?filter.p.vendor=Wargame+Trader&") ?
          url : url.replace("?", "?filter.p.vendor=Wargame+Trader&");
        FacetFiltersForm.updateCardData();
        activeFilters[activeFilters.length - 2].style.display = "none";
        mobileActiveFilters[mobileActiveFilters.length - 1].style.display = "none";
      } else {
        if (global_product_checkbox) {
            FacetFiltersForm.applyGlobalVendorFilter(global_product_checkbox);
        } else {
          setTimeout(function (){
            var global_product_checkbox = document.querySelector('input[value="Wargame Trader"]');
            if (global_product_checkbox) {
              FacetFiltersForm.applyGlobalVendorFilter(global_product_checkbox);
            } else {
                if (loadingSpinner) loadingSpinner.classList.add('hidden');
                globalContentLoadingDiv.classList.remove('hidden');
                globalContentLoadingDiv.parentElement.parentElement.classList.remove('hidden', 'wgt-content-pending');
                document.getElementsByClassName('footer')[0].style.marginTop = '0px';
            }
          }, 150);
        }
      }
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static updateCardData() {
    const loadingSpinner = document.getElementsByClassName('custom-page-fully-loaded-spinner')[0];
    const globalContentLoadingDiv = document.getElementById('ProductGridContainer');
    if (loadingSpinner) loadingSpinner.classList.add('hidden');
    globalContentLoadingDiv.classList.remove('hidden');
    globalContentLoadingDiv.parentElement.parentElement.classList.remove('hidden', 'wgt-content-pending');
    document.getElementsByClassName('footer')[0].style.marginTop = '0px';

    const allowedSortOptions = ["title-descending", "title-ascending", "created-ascending", "created-descending", "relevance"];
    [...[...document.getElementsByClassName("facet-filters__sort")][0].options].forEach(option => {
      if (!allowedSortOptions.includes(option.value)) {
        option.remove();
      }
    });
    const mobileSort = document.getElementById("SortBy-mobile");
   if (mobileSort) {
     [...mobileSort.options].forEach(option => {
        if (!allowedSortOptions.includes(option.value)) {
          option.remove();
        }
      });
    }
    FacetFiltersForm.syncCountryStockFilters();
  }

  static applyGlobalVendorFilter(globalProductCheckbox) {
    globalProductCheckbox.checked = true;
    const forms = [];

    document.querySelectorAll('facet-filters-form form').forEach((form) => {
      if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
        forms.push(new URLSearchParams(new FormData(form)).toString());
      }
    });

    FacetFiltersForm.renderPage(FacetFiltersForm.ensureGlobalVendorFilter(forms.join('&')), null, false);
  }

  static getCountryFilterKey(countryName) {
    return countryName ? countryName.replace(/ /g, '_').toLowerCase() : null;
  }

  static getActiveCountryKey(countryKey) {
    return countryKey || FacetFiltersForm.getFallbackCountryKey();
  }

  static getSupportedCountryKeys() {
    return ['united_states', 'united_kingdom', 'canada'];
  }

  static getCountryStockFilterParam(countryKey) {
    return `filter.p.m.custom.${FacetFiltersForm.getActiveCountryKey(countryKey)}_in_stock`;
  }

  static syncCountryFilterMarkup(countryKey, applyExternalStockFilter = false) {
    const activeCountryKey = FacetFiltersForm.getActiveCountryKey(countryKey);
    FacetFiltersForm.pruneStockFilters(activeCountryKey);
    FacetFiltersForm.prunePriceFilters(activeCountryKey);
    if (applyExternalStockFilter) {
      FacetFiltersForm.applyExternalCountryStockFilter(activeCountryKey);
    }
  }

  static hasGlobalVendorFilter(searchParams = '') {
    const normalizedParams = new URLSearchParams(searchParams || '');
    return normalizedParams.getAll('filter.p.vendor').includes('Wargame Trader');
  }

  static ensureGlobalVendorFilter(searchParams = '') {
    const normalizedParams = new URLSearchParams(searchParams || '');

    if (!normalizedParams.getAll('filter.p.vendor').includes('Wargame Trader')) {
      normalizedParams.append('filter.p.vendor', 'Wargame Trader');
    }

    return normalizedParams.toString();
  }

  static hasExternalReferrer() {
    if (!document.referrer) return false;

    try {
      return new URL(document.referrer).origin !== window.location.origin;
    } catch (error) {
      return false;
    }
  }

  static ensureCountryStockFilter(searchParams = '', countryKey) {
    const normalizedParams = new URLSearchParams(searchParams || '');

    FacetFiltersForm.getSupportedCountryKeys().forEach((key) => {
      normalizedParams.delete(`filter.p.m.custom.${key}_in_stock`);
    });
    normalizedParams.set(FacetFiltersForm.getCountryStockFilterParam(countryKey), '1');

    return normalizedParams.toString();
  }

  static applyExternalCountryStockFilter(countryKey) {
    const currentSearchParams = FacetFiltersForm.searchParamsPrev || FacetFiltersForm.searchParamsInitial;
    const filteredSearchParams = FacetFiltersForm.ensureCountryStockFilter(currentSearchParams, countryKey);

    if (filteredSearchParams === currentSearchParams) return;

    const visibleSearchParams = FacetFiltersForm.ensureCountryStockFilter(
      FacetFiltersForm.searchParamsInitial,
      countryKey
    );
    const visibleUrl = `${window.location.pathname}${visibleSearchParams ? `?${visibleSearchParams}` : ''}${window.location.hash}`;

    FacetFiltersForm.searchParamsInitial = visibleSearchParams;
    history.replaceState({ searchParams: filteredSearchParams }, '', visibleUrl);
    FacetFiltersForm.renderPage(filteredSearchParams, null, false);
  }

  static getFallbackCountryKey() {
    const countryCode =
      window.Shopify?.country ||
      window.__st?.country ||
      (navigator.language || '').split('-')[1] ||
      'US';

    const countryMap = {
      US: 'united_states',
      GB: 'united_kingdom',
      UK: 'united_kingdom',
      CA: 'canada',
    };

    return countryMap[String(countryCode).toUpperCase()] || 'united_states';
  }

  static pruneStockFilters(countryKey) {
    const activeCountryKey = FacetFiltersForm.getActiveCountryKey(countryKey);
    const stockFilterSelectors = {
      desktop: 'details[id*="filter.p.m.custom."][id*="_in_stock"]',
      mobile: 'details[id*="Details-Mobile-filter.p.m.custom."][id*="_in_stock"]',
    };

    Object.values(stockFilterSelectors).forEach((selector) => {
      const stockFilters = [...document.querySelectorAll(selector)].filter((element) =>
        FacetFiltersForm.getSupportedCountryKeys().some((key) => element.id.includes(`${key}_in_stock`))
      );

      stockFilters.forEach((element) => {
        if (!element.id.includes(`${activeCountryKey}_in_stock`)) {
          element.remove();
        }
      });
    });

    const stockFilter = document.querySelector(`details[id*="${activeCountryKey}_in_stock"]`);
    const mobileStockFilter = document.querySelector(`details[id*="Details-Mobile-filter.p.m.custom.${activeCountryKey}_in_stock"]`);

    [stockFilter, mobileStockFilter].forEach((element) => {
      if (element && element.getElementsByTagName('input').length === 0) {
        element.lastElementChild.innerHTML = '<p style="font-size: 12px; font-weight: bold;">None</p>';
      }
    });

    ['#FacetFiltersForm', '#FacetFiltersFormMobile'].forEach((scopeSelector) => {
      const inStockFilters = [...document.querySelectorAll(`${scopeSelector} details`)].filter((element) => {
        const summaryLabel = element.querySelector('.facets__summary-label, .mobile-facets__summary > div');
        return summaryLabel && summaryLabel.textContent.trim() === 'In Stock';
      });

      inStockFilters.slice(1).forEach((element) => element.remove());
    });
  }

  static prunePriceFilters(countryKey) {
    const activeCountryKey = FacetFiltersForm.getActiveCountryKey(countryKey);
    const priceFilterParams = {
      united_states: 'filter.p.m.custom.price_filters',
      united_kingdom: 'filter.p.m.custom.uk_price_range',
      canada: 'filter.p.m.custom.canada_price_range',
    };
    const activePriceFilterParam = priceFilterParams[activeCountryKey] || priceFilterParams.united_states;

    Object.values(priceFilterParams).forEach((priceFilterParam) => {
      if (priceFilterParam === activePriceFilterParam) return;

      document.querySelectorAll(`details[id*="${priceFilterParam}-"]`).forEach((element) => element.remove());
    });
  }

  static syncCountryStockFilters() {
    const shouldApplyExternalStockFilter =
      !FacetFiltersForm.externalStockFilterHandled && FacetFiltersForm.hasExternalReferrer();

    if (shouldApplyExternalStockFilter) {
      FacetFiltersForm.externalStockFilterHandled = true;
    }

    const browsingContextPromise = window.getWgtBrowsingContext
      ? window.getWgtBrowsingContext()
      : fetch('/browsing_context_suggestions.json').then((response) => response.json());

    browsingContextPromise
      .then((data) => {
        const countryKey = FacetFiltersForm.getCountryFilterKey(data?.detected_values?.country?.name);
        FacetFiltersForm.syncCountryFilterMarkup(countryKey, shouldApplyExternalStockFilter);
      })
      .catch(() => {
        FacetFiltersForm.syncCountryFilterMarkup(null, shouldApplyExternalStockFilter);
      });
  }

  static renderPage(searchParams, event, updateURLHash = true, pageParam='') {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}${pageParam}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static clearLoadingState() {
    const productGridContainer = document.getElementById('ProductGridContainer');
    const collection = productGridContainer?.querySelector('.collection');
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );

    collection?.classList.remove('loading');
    countContainer?.classList.remove('loading');
    countContainerDesktop?.classList.remove('loading');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static parseSectionHtml(html) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const productGridContainer = parsedHtml.getElementById('ProductGridContainer');
    const productCount = parsedHtml.getElementById('ProductCount');

    if (!productGridContainer || !productCount) {
      throw new Error('Facet response missing required collection nodes');
    }

    return parsedHtml;
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Facet fetch failed with status ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {
        const parsedHtml = FacetFiltersForm.parseSectionHtml(responseText);
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(parsedHtml, event);
        FacetFiltersForm.renderProductGridContainer(parsedHtml);
        FacetFiltersForm.renderProductCount(parsedHtml);
        FacetFiltersForm.updateCardData();
      })
      .catch((error) => {
        console.error('Facet filter update failed', error);
        FacetFiltersForm.updateCardData();
      })
      .finally(() => {
        FacetFiltersForm.clearLoadingState();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    try {
      const parsedHtml = FacetFiltersForm.parseSectionHtml(html);
      FacetFiltersForm.renderFilters(parsedHtml, event);
      FacetFiltersForm.renderProductGridContainer(parsedHtml);
      FacetFiltersForm.renderProductCount(parsedHtml);
      FacetFiltersForm.updateCardData();
    } catch (error) {
      console.error('Facet cached update failed', error);
    } finally {
      FacetFiltersForm.clearLoadingState();
    }
  }

  static renderProductGridContainer(parsedHtml) {
    // If we're already filtering by wargame trader products
    var activeFilters = document.getElementsByClassName("active-facets");
    var mobileActiveFilters = document.getElementsByClassName("active-facets-mobile");
    const mobileProductFilterQuery = '[id*="Details-Mobile-filter.p.vendor-template"]';
    if (!window.location.href.includes("?filter.p.vendor=Wargame+Trader&")) {
        var global_product_filter = document.querySelector('[aria-label="Products (1 selected)"]');
        if (!global_product_filter) {
            var global_product_checkbox = document.querySelector('input[value="Wargame Trader"]');
            if (global_product_checkbox) {
                global_product_checkbox.click();
            }
          return;
        }
        var mobileProductFilter = document.querySelector(mobileProductFilterQuery);
        global_product_filter.style.display = "none";
        global_product_filter.parentElement.style.marginRight = '0px';
        if (mobileProductFilter) {
          mobileProductFilter.style.display = "none";
        }
        activeFilters[activeFilters.length - 2].style.display = "none";
        mobileActiveFilters[mobileActiveFilters.length - 1].style.display = "none";
    } else {
      var global_product_filter = document.querySelector('[aria-label="Products (1 selected)"]');
      var mobileActiveFilters = document.getElementsByClassName("active-facets-mobile");
      if(activeFilters && global_product_filter) {
        var mobileProductFilter = document.querySelector(mobileProductFilterQuery);
        global_product_filter.style.display = "none";
        global_product_filter.parentElement.style.marginRight = '0px';

        if (mobileProductFilter) {
          mobileProductFilter.style.display = "none";
        }
        activeFilters[activeFilters.length - 2].style.display = "none";
        mobileActiveFilters[mobileActiveFilters.length - 1].style.display = "none";
      }
    }
    document.getElementById('ProductGridContainer').innerHTML =
      parsedHtml.getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(parsedHtml) {
    const count = parsedHtml.getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(parsedHTML, event) {
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    if (facetDetailsElementsFromFetch.length === 0) {
      console.warn('Facet response missing filter markup; preserving existing filters');
      return;
    }

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    const pageParamRegex = /&page=\d+/g;
    const pageParamArray = window.location.href.match(pageParamRegex);
    let pageParam = '';

    if (pageParamArray && event.target.id.includes('Filter-filter.p.vendor-')) {
      pageParam = pageParamArray[0];
    }
    FacetFiltersForm.renderPage(searchParams, event, false, pageParam);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.externalStockFilterHandled = false;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
